import { BoxFlagControl } from "../../../Composites/BoxFlagControl/BoxFlagControl";

export const BoxFlagSectionComposite = props => {
  const handleChange = nextValue => {
    const rule = props.rule.Clone();
    rule.SetTriColor1(nextValue.fFlagColor1, props.actionType);
    rule.SetTriColor2(nextValue.fFlagColor2, props.actionType);
    rule.SetTriColor3(nextValue.fFlagColor3, props.actionType);
    rule.SetTriLabel(nextValue.fFlagLabel, props.actionType);
    rule.SetTriPosition(nextValue.fTriPosition, props.actionType);
    props.setRule(rule);
  };

  return (
    <BoxFlagControl
      openCtrlRef={props.openCtrlRef}
      disabled={props.disabled}
      value={{
        fFlagColor1: props.rule.GetTriColor1(props.actionType),
        fFlagColor2: props.rule.GetTriColor2(props.actionType),
        fFlagColor3: props.rule.GetTriColor3(props.actionType),
        fFlagLabel: props.rule.GetTriLabel(props.actionType),
        fTriPosition: props.rule.GetTriPosition(props.actionType)
      }}
      onChange={handleChange}
    />
  );
};
